import { jsx } from 'react/jsx-runtime';
import { IconBase } from '@vds/core';

const LeftCaretRegular = (props) => (jsx(IconBase, Object.assign({}, props, { svgContent: jsx("path", { d: "M9.5749502,18.9990997L25.9374523,2.6366l2.4876499,2.48769-13.8747492,13.8748097,13.8747492,13.8764992-2.4876499,2.4877014c-.000001,0-16.3625021-16.3642006-16.3625021-16.3642006Z" }), viewBox: "0 0 38 38", iconName: "left-caret-regular" })));
LeftCaretRegular.displayName = 'VDS_Icon';

export { LeftCaretRegular as default };
